import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export abstract class BaseStorageService {
    protected browserLocalStorage: Storage = {
        clear: function (): void {},
        length: 0,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        getItem: function (key: string): string | null {
            return null;
        },
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        key: function (index: number): string | null {
            return null;
        },
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        removeItem: function (key: string): void {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        setItem: function (key: string, value: string): void {},
    };

    constructor(@Inject(PLATFORM_ID) private platformId: object) {
        if (isPlatformBrowser(this.platformId)) {
            this.browserLocalStorage = localStorage;
        }
    }
}
